'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'spacerElement': 'ccl-375685ab35766384',
  'unstyledButton': 'ccl-c0ea52ac936ae58f',
  'isDisabled': 'ccl-e1ea591b6dd1bae5',
  'isBlock': 'ccl-f5bf3e4cae788699'
};

/**
 * A wrapper component used to turn its content clickable. Useful for
 * any clickable UI that doesn't look like a traditional button.
 */

var UnstyledButton = function UnstyledButton(_ref) {
  var _classnames2;

  var children = _ref.children,
      id = _ref.id,
      ariaLabel = _ref.ariaLabel,
      shouldSubmit = _ref.shouldSubmit,
      isDisabled = _ref.isDisabled,
      isBlock = _ref.isBlock,
      onClick = _ref.onClick,
      spacing = _ref.spacing,
      adjacentVerticalSpacing = _ref.adjacentVerticalSpacing,
      adjacentHorizontalSpacing = _ref.adjacentHorizontalSpacing;

  var spacerClasses = (0, _classnames4.default)(styles.spacerElement, _defineProperty({}, styles.isBlock, isBlock));

  var buttonClasses = (0, _classnames4.default)(styles.unstyledButton, (_classnames2 = {}, _defineProperty(_classnames2, styles.isDisabled, isDisabled), _defineProperty(_classnames2, styles.isBlock, isBlock), _classnames2));

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'span',
      className: spacerClasses,
      spacing: spacing,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing
    },
    _react2.default.createElement(
      'button',
      {
        id: id,
        className: buttonClasses,
        type: shouldSubmit ? 'submit' : 'button',
        disabled: isDisabled,
        'aria-label': ariaLabel,
        onClick: onClick
      },
      children
    )
  );
};

UnstyledButton.displayName = 'UnstyledButton';
UnstyledButton.propTypes = _extends({
  /** Content that will make up your button. Contrary to regular buttons this can be anything you want to be clickable. */
  children: _propTypes2.default.node.isRequired,

  /** The DOM id for the underlying BUTTON element. */
  id: _propTypes2.default.string,

  /** String that describes the content of this component if children isn't a string. */
  ariaLabel: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.string, function (props) {
    return typeof props.children !== 'string';
  }),

  /** Sets the 'type' attribute to 'submit' for the case where this button should submit the form it's wrapped in. */
  shouldSubmit: _propTypes2.default.bool,

  /** Disable the default behaviour and any onClick handler. */
  isDisabled: _propTypes2.default.bool,

  /** Whether the component should be full width or not. */
  isBlock: _propTypes2.default.bool,

  /** Event that will be fired when the button is clicked */
  onClick: _propTypes2.default.func.isRequired

}, _SpacerElement2.default.propTypes);

UnstyledButton.defaultProps = {
  id: undefined,
  ariaLabel: undefined,
  shouldSubmit: false,
  isDisabled: false,
  isBlock: false
};

exports.default = UnstyledButton;